import { useEffect, useState, useRef, useContext } from "react";
import FindSimilarFunction from "../utilities/FindSimilarFunction";
import Swatch from "./Swatch";
import { downArrowIcon } from "./Icons";
import singleStyle from "../styles/single.module.scss";
import { UserContext } from "../context/UserContext";
import { isVendorUser } from "../utilities/AuthState";
import { isDesignerHiddenStatus } from "../utilities/MaterialDetails";

function FilteredLibrary({ id, terms, vendor, title, allMaterials, control }) {
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const myRef = useRef(null);
  const orderBy = "none";
  const { userInformation } = useContext(UserContext);

  useEffect(() => {
    const similar = FindSimilarFunction(
      id,
      terms,
      title,
      allMaterials,
      orderBy,
      control,
    );
    setFilteredMaterials(
      isVendorUser(userInformation)
        ? similar
        : similar.filter((item) => !isDesignerHiddenStatus(item.status)),
    );
    // eslint-disable-next-line
  }, [allMaterials, terms, control, userInformation]);

  const executeScroll = () => {
    const barHeight = "90px";
    myRef.current.style.scrollMargin = barHeight;
    myRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div
        id="similarWindow"
        ref={myRef}
        className={singleStyle.singleSimilarHeader}
      >
        <div className={singleStyle.singleSimilarHeading}>
          <h4>Similar Materials</h4>
          <h5>
            {filteredMaterials?.length === 1
              ? "Only 1 close match to "
              : `${filteredMaterials.length} close matches to `}
            <span className={singleStyle.singleSimilarSubject}>
              {vendor} {title}
            </span>
          </h5>
        </div>
        <div className={singleStyle.scrollarrow} onClick={executeScroll}>
          {downArrowIcon}
        </div>
      </div>
      <div className={singleStyle.singleSimilarLibrary}>
        {filteredMaterials?.map((material) => (
          <Swatch key={material.id} id={material.id} />
        ))}
      </div>
    </>
  );
}

export default FilteredLibrary;
